export const QuotedRateIcon = ({ color = "#155DFC" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_18200_12886)">
        <path
          d="M10.6247 1.41602H4.24967C3.87395 1.41602 3.51362 1.56527 3.24794 1.83095C2.98226 2.09662 2.83301 2.45696 2.83301 2.83268V14.166C2.83301 14.5417 2.98226 14.9021 3.24794 15.1678C3.51362 15.4334 3.87395 15.5827 4.24967 15.5827H12.7497C13.1254 15.5827 13.4857 15.4334 13.7514 15.1678C14.0171 14.9021 14.1663 14.5417 14.1663 14.166V4.95768L10.6247 1.41602Z"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91699 1.41602V4.24935C9.91699 4.62507 10.0662 4.98541 10.3319 5.25108C10.5976 5.51676 10.9579 5.66602 11.3337 5.66602H14.167"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08366 6.375H5.66699"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3337 9.20898H5.66699"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3337 12.041H5.66699"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_18200_12886">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
